export default __webpack_public_path__ + "static/media/controlMoreAndroid24.7bfb3d91.svg";